export enum ExecutionType {
  PARSER = 'PARSER',
  ANONYMIZER = 'ANONYMIZER',
  DICOM_UPLOAD = 'DICOM_UPLOAD',
  DXA_UPLOAD = 'DXA_UPLOAD',
  DXA_QUERY = 'DXA_QUERY',
  DICOMIZER = 'DICOMIZER',
  DICOM_CREATOR = 'DICOM_CREATOR',
  QC_EXPORT = 'QC_EXPORT',
  QC_IMPORT = 'QC_IMPORT',
  QCT = 'QCT',
}

export enum ExecutionStatus {
  IN_PROGRESS = 'IN_PROGRESS',
  CREATED = 'CREATED',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
}

export type RunProcessType = {
  clinicalTrialInstrumentId: string;
  clinicalTrialId: string;
  processName?: string;
  workflowType?: string;
  taskId: string;
  data: unknown;
};

export type Attributes = {
  [key: string]: string;
};

export type WorkflowExecution = {
  id: string | null;
  attributes: Attributes;
  executionId: string;
  started: string;
  finished: string;
  type: ExecutionType;
  /** QCT executions only: splits a workstation query from a "Send to QCT" export. */
  name?: 'QCT_UPLOAD' | 'QCT_QUERY';
  status: ExecutionStatus;
  description?: string;
  request?: unknown;
  response?: unknown;
};

export type TaskExecutionImportInitTypeResponse = {
  signedUrl: string;
  executionFileId: string;
};

export type TaskExecutionExportResult = TaskExecutionImportInitTypeResponse;
